import React from "react";
import PropTypes from "prop-types";
import createReactClass from "create-react-class";
import Wall from "./wall";

export default createReactClass({
  displayName: "Root",
  PropTypes: {
    wallId: PropTypes.number.isRequired,
    currentUser: PropTypes.object,
    isCommentShow: PropTypes.bool.isRequired,
    isBodyShow: PropTypes.bool.isRequired,
  },
  getInitialState() {
    return {
      wall: {},
      wallsLikeUsers: [],
      isLiked: false,
      likeCount: 0,
    };
  },
  loadWall() {
    $.ajax({
      url: "/api/walls",
      type: "GET",
      cache: false,
      data: {
        wall_id: this.props.wallId,
      },
    })
      .done(
        function(data) {
          const currentUserId = this.props.currentUser
            ? this.props.currentUser.id
            : 0;
          this.setState({
            wall: data.wall,
            wallsLikeUsers: data.walls_like_users,
            isLiked: data.walls_like_users
              .map(function(like_user) {
                return like_user.user_id;
              })
              .includes(currentUserId)
              ? true
              : false,
            likeCount: data.walls_like_users ? data.walls_like_users.length : 0,
          });
        }.bind(this)
      )
      .fail(function() {}.bind(this));
  },
  componentDidMount() {
    this.loadWall();
  },
  render() {
    const currentUser = this.props.currentUser;
    const wall = this.state.wall;
    const wallsLikeUsers = this.state.wallsLikeUsers;
    return (
      <Wall
        wallId={this.props.wallId}
        wall={wall}
        wallsLikeUsers={wallsLikeUsers}
        currentUser={currentUser}
        isBodyShow={this.props.isBodyShow}
        isCommentShow={this.props.isCommentShow}
      />
    );
  },
});
